<template>
	<div class="con">
		<div class="head">
			<div class="head-bot">
				<van-tabs v-model="headActive" @change='staOnChange' color="#27bec4">
					<van-tab title="总览"></van-tab>
					<van-tab title="门诊"></van-tab>
					<van-tab title="住院"></van-tab>
				</van-tabs>
			</div>
		</div>
		<div class="time-quantum">
			<van-cell title="选择日期时间段" :value="date" @click="show = true" />
			<van-calendar v-model="show" type="range" :default-date="defaTime" @confirm="onConfirm" :min-date="minDate"
			 :max-date="maxDate" color="#43c6cb" />
		</div>
		<div class="total-con" v-if="noImgShow == false">
			<div class="total-title">
				<div class="total-title-left">住院总览</div>
			</div>
			<div class="list">
				<div class="list-con">
					<div class="list-c-title">
						<div class="list-c-text">出院人次</div>
						<div class="list-c-num">{{list.CYRC}}</div>
					</div>
					<div class="list-c-title">
						<div class="list-proportion">环比：<span>{{list.CYHB}}</span></div>
						<div class="list-proportion">同比：<span>{{list.CYTB}}</span></div>
					</div>
				</div>
				<div class="list-con">
					<div class="list-c-title">
						<div class="list-c-text">入院人次</div>
						<div class="list-c-num">{{list.RYRC}}</div>
					</div>
					<div class="list-c-title">
						<div class="list-proportion">环比：<span>{{list.CYHB}}</span></div>
						<div class="list-proportion">同比：<span>{{list.CYTB}}</span></div>
					</div>
				</div>
				<div class="list-con">
					<div class="list-c-title">
						<div class="list-c-text">在院人次</div>
						<div class="list-c-num">{{list.ZYRC}}</div>
					</div>
					<div class="list-c-title">
						<div class="list-proportion">环比：<span>{{list.ZYHB}}</span></div>
						<div class="list-proportion">同比：<span>{{list.ZYTB}}</span></div>
					</div>
				</div>
				<div class="list-con">
					<div class="list-c-title">
						<div class="list-c-text">死亡人次</div>
						<div class="list-c-num">{{list.SWRC}}</div>
					</div>
					<div class="list-c-title">
						<div class="list-proportion">环比：<span>{{list.SWHB}}</span></div>
						<div class="list-proportion">同比：<span>{{list.SWTB}}</span></div>
					</div>
				</div>
			</div>
		</div>
		<div class="noImg" v-if="noImgShow == true">
			<img src="../assets/404.gif" />
			<div class="no-text">无清单列表~~</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'inHospital',
		data() {
			return {
				headActive: 2,
				date: '', //显示的时间段
				show: false,
				minDate: '',
				maxDate: '',
				Choose: '', //选择的时间段
				defaTime: '', //进入页面默认的时间段
				list: [],
				noImgShow: false,
			}
		},
		methods: {
			//获取数据
			GetInpatDataReport() {
				this.$store.commit('Load', true)
				this.$Axios.Get('/other/getInpatDataReport?startDate=' + this.Choose[0] + '&endDate=' + this.Choose[1], null).then(res => {
					console.log(res)
					this.$store.commit('Load', false)
					if (res.code == 0) {
						this.list = res.msg;
					}else{
						this.noImgShow = true
					}
				}).catch(err => {
					this.$store.commit('Load', false)
					console.log(err)
					this.noImgShow = true
				})
			},
			//导航
			staOnChange(event) {
				if (event == 0) {
					this.$router.replace({
						path: '/statistical'
					})
				} else if (event == 1) {
					this.$router.replace({
						path: '/staOutpatient'
					})
				}
			},
			formatDate(date) {
				return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
			},
			onConfirm(date) {
				const [start, end] = date;
				this.show = false;
				this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
				this.Choose = [`${this.formatDate(start)}`, `${this.formatDate(end)}`];

				this.GetInpatDataReport();
				this.noImgShow = false;
			},
			//时间段
			timeQuantum() {
				let newT = new Date();
				let minT = newT - 1000 * 60 * 60 * 24 * 30 * 12 * 5; //只能查当前时间 往前的5年信息

				this.maxDate = newT;
				this.minDate = new Date(minT);

				let newYear = newT.getFullYear() + "/1/1";

				this.defaTime = [new Date(newYear), new Date()]
				this.date = `${this.formatDate(new Date(newYear))} - ${this.formatDate(new Date())}`;
				this.Choose = [`${this.formatDate(new Date(newYear))}`, `${this.formatDate(new Date())}`]

				this.GetInpatDataReport();
			},
		},
		mounted() {

		},
		created() {
			this.timeQuantum();
		},
	}
</script>

<style scoped>
	.con {
		width: 100%;
		height: 100%;
	}

	.time-quantum {
		margin: 10px 0;
		background-color: #f0f0f0;
	}

	.total-con {
		padding: 10px 20px;
		background-color: #fff;
	}

	.total-title {
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.total-title-left {
		font-weight: 700;
		font-size: 18px;
		color: #000;
	}

	.total-title-right {
		font-size: 14px;
		color: #999;
	}

	.total-num {
		padding: 10px;
		color: #fff;
		background: #27bec4;
		border-radius: 5px;
	}

	.totol-min {
		margin: 10px 0;
		font-size: 12px;
	}

	.t-r-title {
		font-size: 12px;
	}

	.total-r-text {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.t-r-num {
		font-weight: 700;
		font-size: 30px;
	}

	.list-con {
		padding: 10px;
		margin: 10px 0;
		border: 1px solid #ccc;
		border-radius: 5px;
	}

	.list-c-title {
		display: flex;
		justify-content: space-between;
		padding: 5px 0;
	}

	.list-c-text {
		color: #333;
		font-size: 15px;
		font-weight: 700;
	}

	.list-c-num {
		font-size: 20px;
		font-weight: 700;
		color: #000000;
	}

	.list-proportion {
		font-size: 14px;
		font-weight: 700;
	}

	.list-proportion span {
		color: #27BEC4;
	}
	.noImg {
		margin-top: 10vh;
		text-align: center;
	}
	
	.no-text {
		margin-top: 10px;
		color: #27BEC4;
		font-size: 16px;
	}
</style>
